import React, { useMemo, useState } from "react";
import Exceptions from "../../components/Downloads/Exceptions";
import JSONDownload from "../../components/Downloads/JSON";
import Document from "../../components/Downloads/Document";
import PAN_INSTA_REPORT from "../../components/Downloads/PAN_InstaReport";
import PolicyReport from "../../components/Downloads/PolicyReport";

const Downloads = () => {
  const tabs = useMemo(
    () => [
      { key: "EXCEPTIONS", label: "Exceptions", Component: Exceptions },
      { key: "JSON", label: "JSON", Component: JSONDownload },
      { key: "DOCUMENT", label: "Document", Component: Document },
      { key: "PAN_INSTA", label: "PAN & Insta", Component: PAN_INSTA_REPORT },
      { key: "POLICY", label: "Policy Report", Component: PolicyReport },
    ],
    []
  );

  const [activeTab, setActiveTab] = useState("EXCEPTIONS");

  const activeItem = tabs.find((tab) => tab.key === activeTab) || tabs[0];
  const ActiveComponent = activeItem?.Component;

  const renderTab = (tab) => {
    const isSelected = activeTab === tab.key;

    return (
      <div
        key={tab.key}
        role="button"
        tabIndex={0}
        onClick={() => setActiveTab(tab.key)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            setActiveTab(tab.key);
          }
        }}
        className={`view-count proposal-dashboard__filter-card downloads-page__tab ${
          isSelected ? "selected" : ""
        }`}
      >
        <span className="proposal-dashboard__filter-label">{tab.label}</span>
      </div>
    );
  };

  return (
    <div className="proposal-dashboard downloads-page">
      <div className="proposal-dashboard__header downloads-page__header">
        <h2 className="proposal-dashboard__title">Downloads</h2>
        <p className="proposal-dashboard__subtitle">
          Track exceptions, JSON payloads, documents, and export reports
        </p>
      </div>

      <div className="view-options proposal-dashboard__filters downloads-page__tabs">
        {tabs.map(renderTab)}
      </div>

      <div className="downloads-page__content">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default Downloads;
